var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFormatList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17319_53804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 8.75C2.64165 8.75 2.08331 9.30833 2.08331 10C2.08331 10.6917 2.64165 11.25 3.33331 11.25C4.02498 11.25 4.58331 10.6917 4.58331 10C4.58331 9.30833 4.02498 8.75 3.33331 8.75ZM3.33331 3.75C2.64165 3.75 2.08331 4.30833 2.08331 5C2.08331 5.69167 2.64165 6.25 3.33331 6.25C4.02498 6.25 4.58331 5.69167 4.58331 5C4.58331 4.30833 4.02498 3.75 3.33331 3.75ZM3.33331 13.75C2.64165 13.75 2.08331 14.3167 2.08331 15C2.08331 15.6833 2.64998 16.25 3.33331 16.25C4.01665 16.25 4.58331 15.6833 4.58331 15C4.58331 14.3167 4.02498 13.75 3.33331 13.75ZM5.83331 15.8333H17.5V14.1667H5.83331V15.8333ZM5.83331 10.8333H17.5V9.16667H5.83331V10.8333ZM5.83331 4.16667V5.83333H17.5V4.16667H5.83331Z",
    fill: "#53A551"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17319_53804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormatList);
export default __webpack_public_path__ + "static/media/icon-format-list.298c2fe0e23ee654435067cce384a932.svg";
export { ForwardRef as ReactComponent };